import * as React from "react";
const SvgDoctor = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M9 14.2349V16.9999C9 18.3259 9.52678 19.5977 10.4645 20.5354C11.4021 21.4731 12.6739 21.9999 14 21.9999H14.882C15.7793 21.9997 16.652 21.7066 17.3675 21.1651C18.0829 20.6236 18.6021 19.8634 18.846 18.9999",
	stroke: "currentColor",
	strokeWidth: 2
}), /* @__PURE__ */ React.createElement("path", {
	d: "M5.429 3H5.337C5.024 3 4.867 3 4.736 3.012C4.03442 3.07406 3.37704 3.38098 2.87901 3.87901C2.38098 4.37704 2.07406 5.03442 2.012 5.736C2 5.868 2 6.024 2 6.336V7.236C2 9.09252 2.7375 10.873 4.05025 12.1857C5.36301 13.4985 7.14348 14.236 9 14.236C9.88178 14.236 10.7549 14.0623 11.5696 13.7248C12.3842 13.3874 13.1244 12.8927 13.7479 12.2692C14.3713 11.6456 14.8659 10.9053 15.2032 10.0906C15.5406 9.27595 15.7141 8.40278 15.714 7.521V6.337C15.714 6.024 15.714 5.867 15.703 5.736C15.6409 5.03442 15.334 4.37704 14.836 3.87901C14.338 3.38098 13.6806 3.07406 12.979 3.012C12.847 3 12.69 3 12.377 3H12.286",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M19 19C20.6569 19 22 17.6569 22 16C22 14.3431 20.6569 13 19 13C17.3431 13 16 14.3431 16 16C16 17.6569 17.3431 19 19 19Z",
	stroke: "currentColor",
	strokeWidth: 2
}), /* @__PURE__ */ React.createElement("path", {
	d: "M12 2V4M6 2V4",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round"
}));
export default SvgDoctor;
